export async function wait (duration?: number) {
    if (!duration) {
        duration = 500;
    }

    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve();
        }, duration);
    });
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/utils/wait.ts